import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { services } from '../../data/mockData';
import './Services.css';

const symbolByLink = {
  '/rgpd': 'pink',
  '/cybersecurite': 'blue',
  '/infogerance': 'orange'
};

const themeByLink = {
  '/rgpd': 'theme-pink',
  '/cybersecurite': 'theme-blue',
  '/infogerance': 'theme-orange'
};

const Services = () => (
  <section className="services-section section" id="expertise">
    <div className="container">
      <div className="section-header">
        <h2 className="section-title fade-in-up">Notre expertise</h2>
        <p className="section-subtitle fade-in-up" style={{ animationDelay: '0.1s' }}>
          Notre métier ? Vous accompagner sur les sujets suivants :
        </p>
      </div>

      <div className="services-grid">
        {services.map((service, index) => (
          <div
            key={service.id}
            className={`service-card glass fade-in-up ${themeByLink[service.link] || ''}`}
            style={{ animationDelay: `${index * 0.15}s` }}
            data-testid={`service-card-${service.link.slice(1)}`}
          >
            <img
              src={`/assets/symbol/symbol-${symbolByLink[service.link] || 'gradient'}.svg`}
              alt=""
              className="service-symbol"
              aria-hidden="true"
            />
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
            <Link to={service.link} className="service-link">
              Découvrir <ArrowRight size={18} />
            </Link>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
